import type { ResourceProps } from 'react-admin';
import TuneIcon from '@mui/icons-material/Tune';

import ItemAdjustedPricesList from './ItemAdjustedPricesList';

export { itemAdjustedPricesDataProvider } from './dataProvider';

const resource: ResourceProps = {
  name: 'resalePricing/itemAdjustedPrices',
  list: ItemAdjustedPricesList,
  icon: TuneIcon,
  options: { label: 'Item Adjusted Prices' },
};

export default resource;
